// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"projectGrid-module--gridContainer--1T0sM","carouselInner":"projectGrid-module--carouselInner--1GIaf"};